import {config} from "../utils2";
import {useEffect, useState} from "react";
import {fetchWrapper} from "../_services/fetch";

const api = config.get_remote_api() + "/api/public"
const endpointPublicTagList = () => `${api}/tags`

const msg = "Failed with no error messages from the server."
const handleSuccess = resp => resp.success ? Promise.resolve(resp?.data) : Promise.reject({message: resp.message || msg})
const handleError = err => err?.name !== "AbortError" ? err?.error || err?.message || msg : null

function temp(endpoint, payload, defaultValue) {
    const [loadingValue, setLoadingValue] = useState(false);
    const [errorValue, setErrorValue] = useState(null);
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        const controller = new AbortController()

        setErrorValue(null)
        setLoadingValue(true)

        // Fetch options
        const requestOptions = {
            method: "POST",
            signal: controller.signal,
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(payload)
        }

        fetchWrapper.generic(endpoint, requestOptions)
            .then(handleSuccess)
            .then(setValue)
            .catch(err => setErrorValue(handleError(err)))
            .finally(() => setLoadingValue(false))

        return () => {
            controller.abort()
            setLoadingValue(false)
        }
    }, []);

    return {
        value,
        setValue,
        loadingValue,
        setLoadingValue,
        errorValue,
        setErrorValue,
        clearError: () => setErrorValue(null)
    }
}

export function usePublicTagList() {
    const payload = {product_only: true}
    return temp(endpointPublicTagList(), payload, [])
}